"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslatedMarkdown = TranslatedMarkdown;
var _react = _interopRequireDefault(require("react"));
var _i18n = require("./i18n");
var _message = require("../message");
/**
 * Renders translated text with limited markdown formatting.
 */
function TranslatedMarkdown({
  i18nKey,
  components,
  count,
  defaults,
  values
}) {
  const text = (0, _i18n.t)(i18nKey, {
    count,
    defaultValue: defaults,
    skipInterpolation: true
  });
  return text ? /*#__PURE__*/_react.default.createElement(_message.Message, {
    em: components?.em,
    link: components?.link,
    params: {
      count,
      ...values
    },
    strong: components?.strong,
    text: text
  }) : null;
}